import React from 'react';

import { usePrefs } from 'wsm-common-data';
import { isInTransit } from 'wsm-highlighted-attribute';

import { checkConcaternateAttr } from '../../../utilities/concatenateAttributeCheck';

import Delivery from './Delivery';
import LocationDistance from './LocationDistance';
import vehiclePropType from '../../../propTypes/vehiclePropType';

const LocationContainer = ({ vehicle }) => {
	const { deliveryEnabled } = usePrefs();
	const { trackingAttributes = [], status, attributes = [] } = vehicle;

	const geodistAttr = trackingAttributes.find(
		(attr) => attr.name === 'geodist'
	)?.value;
	const distance = geodistAttr ? parseInt(geodistAttr, 10) : null;
	const showDelivery =
		deliveryEnabled === 'true' && !isInTransit(status) && distance !== null;

	const locationDistanceObj = attributes.find(
		(item) => item.name === 'locationDistance'
	);
	let locationDistanceLabel = locationDistanceObj?.labeledValue;
	if (!checkConcaternateAttr('locationDistance', locationDistanceLabel)) {
		locationDistanceLabel = locationDistanceObj?.value;
	}

	if (!showDelivery && !locationDistanceLabel) return null;

	return (
		<div className="mb-3">
			{showDelivery && <Delivery distance={distance} />}
			{locationDistanceLabel && (
				<LocationDistance
					label={locationDistanceLabel}
					accountId={vehicle.accountId}
				/>
			)}
		</div>
	);
};

LocationContainer.propTypes = {
	vehicle: vehiclePropType.isRequired
};

export default LocationContainer;
